var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.36669C2.99989 8.28358 3.01114 8.20127 3.03312 8.12449C3.05509 8.04771 3.08735 7.97799 3.12804 7.91933L5.3657 4.67982C5.66653 4.24454 6.07454 4 6.49998 4C6.92542 4 7.33343 4.24454 7.63427 4.67982L9.87192 7.91933C9.91254 7.97814 9.94476 8.04794 9.96673 8.12476C9.98871 8.20158 10 8.28391 10 8.36705C9.99999 8.45019 9.98866 8.53251 9.96665 8.60931C9.94465 8.68612 9.91241 8.7559 9.87178 8.81467C9.83114 8.87345 9.7829 8.92007 9.72981 8.95186C9.67672 8.98366 9.61982 9.00002 9.56236 9C9.5049 8.99998 9.44801 8.98359 9.39493 8.95175C9.34185 8.91992 9.29363 8.87327 9.25301 8.81446L7.01565 5.57495C6.94793 5.47695 6.86754 5.3992 6.77906 5.34616C6.69059 5.29312 6.59575 5.26582 6.49998 5.26582C6.40421 5.26582 6.30938 5.29312 6.2209 5.34616C6.13242 5.3992 6.05203 5.47695 5.98432 5.57495L3.74696 8.81278C3.68584 8.90127 3.60797 8.96157 3.52319 8.98607C3.43841 9.01058 3.35051 8.99818 3.27059 8.95045C3.19067 8.90273 3.12231 8.8218 3.07415 8.71791C3.026 8.61401 3.00019 8.49179 3 8.36669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/ChevronUp.34724265ef84e289249cb8dba9692c06.svg";
export { ForwardRef as ReactComponent };